import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {clsx} from 'clsx';
import React from 'react';

import {Banner, BannerFlexWrapper, BannerTextWrapper} from './Banner';

export const WeRecommendAlertAutomations = ({
  variant,
}: {
  variant?: 'dark' | 'light';
}) => {
  variant = variant ?? 'light';
  return (
    <Tailwind>
      <Banner
        variant="announcement"
        className={clsx(
          'mb-20',
          variant === 'dark' && 'bg-gold-700 bg-opacity-30'
        )}>
        <BannerFlexWrapper>
          <Icon
            name="info"
            className={clsx(variant === 'dark' && 'text-gold-300')}
          />
          <BannerTextWrapper>
            <div className={clsx(variant === 'dark' && 'text-gold-300')}>
              <span className="font-semibold">
                We recommend alert automations.
              </span>{' '}
              Project automations now offer new trigger events including 'Run
              status change'. Also find per-automation Slack channel selection.
            </div>
          </BannerTextWrapper>
        </BannerFlexWrapper>
      </Banner>
    </Tailwind>
  );
};
